<app-dialog
  [dialogType]="dialogType"
  [trackingScreenName]="trackingScreenName"
  [trackingDialogName]="trackingDialogName"
  [primaryActionText]="primaryActionText"
  [primaryActionTapped]="primaryActionTapped"
  [secondaryActionText]="secondaryActionText"
  [secondaryActionTapped]="secondaryActionTapped"
  (onPrimaryAction)="primaryAction.emit()"
  (onSecondaryAction)="secondaryAction.emit()"
>
  <h1>{{ text }}</h1>
</app-dialog>
